import { serializeMobilityLinePricing } from '../fields/mobilityLinePricing';
import { cloneConfig, validateOfferEditor } from './commonEditorModel';
import { numberFromInput, serializeSharedProductFields } from './editorProductFields';

const priceFields = ['price', 'regularPrice'];

export const validateCatalogEditor = (scope, values = {}, getMobilityLinePricingErrors = () => []) => {
    const errors = validateOfferEditor(values, { priceFields });
    if (scope === 'mobility') {
        errors.push(...getMobilityLinePricingErrors(values.linePricing));
    }
    return errors;
};

export const serializeCatalogEditor = (sourceConfig, editor, archivedAt) => {
    const nextConfig = cloneConfig(sourceConfig);
    let products = [];
    if (editor.scope === 'mobility') {
        products = nextConfig.products.mobility.products || [];
    } else if (editor.scope === 'security') {
        products = nextConfig.products.security.products || [];
    } else if (editor.scope === 'addons') {
        const group = (nextConfig.products.addons.groups || []).find((candidate) => candidate.id === editor.groupId);
        products = group?.items || [];
    }

    const index = products.findIndex((product) => product.id === editor.originalId);
    if (index === -1 && !editor.isNew) {
        throw new Error(`Unable to find the selected ${editor.scope} product in the draft config.`);
    }

    const values = editor.values;
    const previous = index === -1 ? {} : products[index];
    const nextProduct = {
        ...previous,
        id: editor.originalId,
        displayName: values.displayName.trim(),
        price: numberFromInput(values.price),
        regularPrice: values.regularPrice === '' ? undefined : numberFromInput(values.regularPrice),
        category: values.category.trim() || undefined,
        type: values.type.trim() || undefined,
        term: values.term.trim() || undefined,
        devices: values.devices.trim() || undefined,
        note: values.note.trim() || undefined,
        recommended: Boolean(values.recommended),
        hot: Boolean(values.hot),
        highlightNote: values.highlightNote.trim(),
        ...serializeSharedProductFields(values, previous, archivedAt),
        separateFlowOnly: Boolean(values.separateFlowOnly),
        allowQuantity: Boolean(values.allowQuantity),
        ...(editor.scope === 'mobility' ? {
            linePricing: serializeMobilityLinePricing(values.linePricing)
        } : {})
    };

    if (index === -1) {
        products.push(nextProduct);
    } else {
        products[index] = nextProduct;
    }
    return nextConfig;
};
